export default {
    created () {
        if (this.$store.state.loginLoading) {
            this.$store.state.loginLoading.close();
          }
    }
}